import classes from "./LastStep.module.css";
import { useStudioErstellen } from "../../store/studioErstellenStore";
import StudioProfile from "../StudioProfile/StudioProfile";

export const LastStep = () => {
    const { studioData } = useStudioErstellen();

    const location = [studioData?.standort?.city, studioData?.standort?.country]
        .filter(Boolean)
        .join(", ");
    
    // Create a preview version of the studio data
    const studio = {
        ...studioData,
        city: studioData?.standort?.city || "",
        location,
        images: studioData.images.map(image => image.previewUrl)
    };

    return (
        <div className={classes.mainContainer}>
            <div className={classes.textContainer}>
                <h2 className={`${classes.title} titleSemibold`}>Veröffentliche dein Studio.</h2>
                <span className="slimRegularLarge">Du kannst deine Angaben jederzeit ändern.</span>
            </div>
            <div className={classes.viewContainer}>
                <StudioProfile renderedBy="StudioErstellen" studio={studio} />
            </div>
        </div>
    );
};

export default LastStep;